import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import styles from "./MerryChristmasPage.module.css";

export default function MerryChristmasPage() {
  const [audioPlaying, setAudioPlaying] = useState(false);

  useEffect(() => {
    document.title = "Merry Christmas 🎄 | Blake Technologies";
  }, []);

  // Stable snowflake positions
  const snowflakes = useMemo(() => {
    return Array.from({ length: 35 }, (_, i) => ({
      id: i,
      left: `${(i * 97) % 100}%`,
      size: 14 + (i % 10),
      duration: 12 + (i % 8),
      delay: (i % 5) * 0.8,
    }));
  }, []);

  const handlePlayAudio = () => {
    const audio = document.getElementById("christmasAudio");
    if (audio) {
    audio.play();
    setAudioPlaying(true);
    }
    };

  return (
    <div className={styles.root}>
      {/* Decorative Layer: Snow, Santa, Fireworks, Ornaments */}
      <div className={styles.decorativeLayer}>
        {/* Background Glow */}
        <div className={styles.backgroundGlow}></div>

        {/* Snowfall */}
        {snowflakes.map((flake) => (
          <motion.div
            key={flake.id}
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: "110vh", opacity: 1 }}
            transition={{ duration: flake.duration, repeat: Infinity, delay: flake.delay }}
            className={styles.snowflake}
            style={{ left: flake.left, fontSize: `${flake.size}px` }}
          >
            ❆
          </motion.div>
        ))}

        {/* Santa Sleigh */}
        <motion.img
          src="https://pngimg.com/uploads/santa_claus/santa_claus_PNG9982.png"
          alt="Santa sleigh"
          initial={{ x: "-30%", y: 80 }}
          animate={{ x: "110%" }}
          transition={{ duration: 18, repeat: Infinity, ease: "linear" }}
          className={styles.santa}
        />

        {/* Fireworks / Confetti Burst */}
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: [0, 1.4, 1], opacity: [0, 1, 0] }}
          transition={{ duration: 1.8 }}
          className={styles.fireworks}
        ></motion.div>

        {/* Floating Ornaments */}
        <motion.img
          src="https://images.unsplash.com/photo-1543589077-47d81606c1bf"
          alt="Christmas ornament"
          animate={{ y: [0, -80, 0], rotate: [-2, 2, -2] }}
          transition={{ duration: 6, repeat: Infinity }}
          className={styles.ornamentLeft}
        />
        <motion.img
          src="https://images.unsplash.com/photo-1543589077-47d81606c1bf"
          alt="Christmas lights"
          animate={{ scale: [1, 1.25, 1] }}
          transition={{ duration: 5, repeat: Infinity }}
          className={styles.ornamentRight}
        />
      </div>

      {/* Main Content Card */}
      <div className={styles.mainCard}>
        {/* Animated Christmas Tree */}
        <motion.img
          src="https://images.unsplash.com/photo-1544025162-d76694265947"
          alt="Christmas Tree"
          animate={{ rotate: [-1, 1, -1] }}
          transition={{ duration: 4, repeat: Infinity }}
          className={styles.tree}
        />

        {/* Title */}
        <motion.h1
          animate={{ scale: [1, 1.25, 1] }}
          transition={{ duration: 3, repeat: Infinity }}
          className={styles.title}
        >
          Merry Christmas 🎄
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
          className={styles.subtitle}
        >
          From all of us at <span className={styles.bold}>Blake Technologies</span>, we wish you joy, warmth, and exciting opportunities ahead. Thank you for building with our platform this year.
        </motion.p>

        {/* Special Thanks List */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className={styles.thanksSection}
        >
          <h2 className={styles.h2}>🎁 Special Thanks</h2>
          <ul>
            {["Emmanuel Dikkoe", "Sylvia Asaah (Showbe)", "Helena Duah (Heleweed🌿)", "Constance Krah", "Abena Darkwah", "S1 of 2018"].map(name => (
              <motion.li key={name} whileHover={{ scale: 1.1 }} className={styles.thankItem}>
                {name}
              </motion.li>
            ))}
          </ul>
        </motion.div>
        <div className={styles.buttonGroup}>
          {!audioPlaying && (
        <button  onClick={handlePlayAudio} className={styles.btnGreen}>
        Play Christmas Jingle 🎵
        </button>
        )}
        </div>
        {/* Buttons */}
        <div className={styles.buttonGroup}>
          <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href="https://baiv.blaketechhq.com" className={styles.btnRed}>
            Go to Dashboard 🎁
          </motion.a>
          <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href="product/ai_vision/docs" className={styles.btnGreen}>
            View Docs ❄️
          </motion.a>
          {/* Play Audio Button */}
        
        <audio id="christmasAudio" src="audio/chi.mp3" autoPlay loop />
        </div>
      </div>

      

      {/* Background Music */}
      {/* <audio src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3" autoPlay loop></audio> */}
    </div>
  );
}
